"use client";

import Image from "next/image";
import styles from "./ImageWithFallback.module.scss";

const FALLBACK_IMAGE_SRC =
  "https://ackodrive-prod.ackoassets.com/_next_static/images/placeHolder-FallbackImage.png";

interface ImageWithFallbackProps {
  src: string;
  fallbackSrc?: string;
  alt: string;
  className?: string;
  /** Applied to the img when fallback is shown. Default: width 70%, height auto */
  fallbackClassName?: string;
  fill?: boolean;
  loading?: "eager" | "lazy";
  fetchPriority?: "high" | "low" | "auto";
  quality?: number;
  sizes?: string;
  priority?: boolean;
}

export default function ImageWithFallback({
  src,
  fallbackSrc = FALLBACK_IMAGE_SRC,
  alt,
  className = "",
  fallbackClassName,
  fill = true,
  loading = "lazy",
  fetchPriority = "auto",
  quality = 90,
  sizes,
  priority = false,
}: ImageWithFallbackProps) {
  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const target = e.target as HTMLImageElement;
    if (target && target.src !== fallbackSrc) {
      target.src = fallbackSrc;
      target.className = fallbackClassName ?? styles.imageFallbackDefault;
    }
  };

  return (
    <Image
      src={src}
      alt={alt}
      fill={fill}
      className={className}
      loading={loading}
      fetchPriority={fetchPriority}
      quality={quality}
      sizes={sizes}
      priority={priority}
      onError={handleError}
    />
  );
}
